import axios from '../../config/axios.js';

export const API = '/api/v1/inko-creation';
export const STORAGE_ANALYZE = 'inko_creation_last_analyze';
export const STORAGE_PROMPT = 'inko_creation_prompt';
export const STORAGE_PRODUCT = 'inko_creation_product_key';

export function money(n) {
  return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
}

export function requireAuth() {
  if (!window.Alpine?.store('auth')?.isLoggedIn) {
    window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
    return false;
  }
  return true;
}

export function saveAnalyze(result) {
  sessionStorage.setItem(STORAGE_ANALYZE, JSON.stringify(result));
}

export function loadAnalyze() {
  try {
    const raw = sessionStorage.getItem(STORAGE_ANALYZE);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAnalyze() {
  sessionStorage.removeItem(STORAGE_ANALYZE);
}

const api = {
  meta: () => axios.get(`${API}/meta`).then(r => r.data.data),
  analyze: (prompt, productKey) => axios.post(`${API}/analyze`, { prompt, product_key: productKey }).then(r => r.data.data),
  listTemplates: (productKey, theme) => axios.get(`${API}/templates`, { params: { product_key: productKey, theme } }).then(r => r.data.data ?? []),
  searchAssets: (params) => axios.get(`${API}/assets`, { params }).then(r => r.data.data ?? []),
  uploadAsset: (form) => axios.post(`${API}/assets`, form).then(r => r.data.data),
  listProjects: (page = 1) => axios.get(`${API}/projects`, { params: { page, per_page: 15 } }).then(r => ({ items: r.data.data ?? [], meta: r.data.meta ?? null })),
  showProject: (id) => axios.get(`${API}/projects/${id}`).then(r => r.data.data),
  createProject: (payload) => axios.post(`${API}/projects`, payload).then(r => r.data.data),
  resolveAssets: (id) => axios.post(`${API}/projects/${id}/resolve-assets`).then(r => r.data.data.project),
  applyTemplate: (id, templateKey) => axios.post(`${API}/projects/${id}/apply-template`, { template_key: templateKey }).then(r => r.data.data.project),
  getCanvas: (id) => axios.get(`${API}/projects/${id}/canvas`).then(r => r.data.data),
  getEditor: (id) => axios.get(`${API}/projects/${id}/editor`).then(r => r.data.data),
  updateLayer: (id, layerId, payload) => axios.patch(`${API}/projects/${id}/layers/${layerId}`, payload).then(r => r.data.data.editor),
  duplicateLayer: (id, layerId) => axios.post(`${API}/projects/${id}/layers/${layerId}/duplicate`).then(r => r.data.data.editor),
  deleteLayer: (id, layerId) => axios.delete(`${API}/projects/${id}/layers/${layerId}`).then(r => r.data.data.editor),
  regenerateLayer: (id, layerId, prompt) => axios.post(`${API}/projects/${id}/layers/${layerId}/regenerate`, { prompt }).then(r => r.data.data),
  listVersions: (id) => axios.get(`${API}/projects/${id}/versions`).then(r => r.data.data ?? []),
  restoreVersion: (id, versionId) => axios.post(`${API}/projects/${id}/versions/${versionId}/restore`).then(r => r.data.data.editor),
  attachAsset: (id, zoneKey, assetId) => axios.post(`${API}/projects/${id}/attach-asset`, { zone_key: zoneKey, asset_id: assetId }).then(r => r.data.data.canvas),
  generateBackground: (id, prompt) => axios.post(`${API}/projects/${id}/generate`, { type: 'background', prompt }).then(r => r.data.data),
  generationStatus: (id) => axios.get(`${API}/projects/${id}/generation-status`).then(r => r.data.data),
  exportPresets: () => axios.get(`${API}/export/presets`).then(r => r.data.data),
  validatePrint: (id) => axios.post(`${API}/projects/${id}/validate-print`).then(r => r.data.data.validation),
  getPrintValidation: (id) => axios.get(`${API}/projects/${id}/print-validation`).then(r => r.data.data.validation ?? null),
  exportProject: (id, payload) => axios.post(`${API}/projects/${id}/export`, payload).then(r => r.data.data),
  listExports: (id) => axios.get(`${API}/projects/${id}/exports`).then(r => r.data.data ?? []),
  exportStatus: (exportId) => axios.get(`${API}/exports/${exportId}`).then(r => r.data.data),
  billingCatalog: () => axios.get(`${API}/billing/catalog`).then(r => r.data.data),
  getSubscription: () => axios.get(`${API}/billing/subscription`).then(r => r.data.data),
  purchaseBilling: (payload) => axios.post(`${API}/billing/purchase`, payload).then(r => r.data.data),
  listCreditTransactions: (page = 1) => axios.get(`${API}/credits/transactions`, { params: { page } }).then(r => ({ items: r.data.data ?? [], meta: r.data.meta ?? null })),
  cancelSubscription: () => axios.post(`${API}/billing/subscription/cancel`).then(r => r.data.data.subscription),
  convertPoints: (points) => axios.post(`${API}/credits/convert-from-points`, { points }).then(r => r.data.data),
  printCatalog: () => axios.get(`${API}/printing/catalog`).then(r => r.data.data),
  printQuote: (id, payload) => axios.post(`${API}/projects/${id}/print-quote`, payload).then(r => r.data.data.quote),
  createPrintOrder: (id, payload) => axios.post(`${API}/projects/${id}/print-order`, payload).then(r => r.data.data.order),
  listPrintOrders: () => axios.get(`${API}/print-orders`).then(r => r.data.data ?? []),
  showPrintOrder: (id) => axios.get(`${API}/print-orders/${id}`).then(r => r.data.data.order),
  payPrintOrder: (id, paymentMethod) => axios.post(`${API}/print-orders/${id}/pay`, { payment_method: paymentMethod }).then(r => r.data.data),
  cancelPrintOrder: (id) => axios.post(`${API}/print-orders/${id}/cancel`).then(r => r.data.data.order),
};

export default api;
